import styled from "styled-components";

const checkboxColumnWidth = 32;
const groupChevronWidth = 32;

export const FiltersRow = styled.div`
  display: flex;
  align-items: stretch;
  width: 100%;
  box-sizing: border-box;
  background: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
`;

export const CheckboxSpacer = styled.div`
  flex: 0 0 ${checkboxColumnWidth}px;
  width: ${checkboxColumnWidth}px;
  box-sizing: border-box;
`;

export const GroupChevronSpacer = styled.div`
  flex: 0 0 ${groupChevronWidth}px;
  width: ${groupChevronWidth}px;
  box-sizing: border-box;
`;

const leftCellPadding = 12;
const rightCellPadding = 8;

const getWidth = (width: number | "auto"): string => {
  if (width === "auto") {
    return "auto";
  }
  return `${width + leftCellPadding + rightCellPadding}px`;
};

export const FilterCell = styled.div<{ $width: number | "auto" }>`
  flex: 0 0 ${({ $width }) => getWidth($width)};
  width: ${({ $width }) => getWidth($width)};
  min-width: ${({ $width }) => getWidth($width)};
  display: flex;
  align-items: center;
  padding-top: 8px;
  padding-bottom: 6px;
  padding-left: ${leftCellPadding}px;
  padding-right: ${rightCellPadding}px;
  box-sizing: border-box;
  overflow: hidden;
`;

export const FilterPlaceholder = styled.div`
  width: 100%;
  min-height: 32px;
`;
